export type OptimizerType =
  | "image_quality_improvement"
  | "posture_correction"
  | "face_beautification"
  | "remove_multi_person";
export type OptimizerItem = {
  value: OptimizerType;
  content: string;
};
export type OptimizerList = Array<OptimizerItem>;

export enum GenerateBizType {
  Presets = 1, //玩图
  Txt2Img = 2, //生成
  Variation = 3, //相似
  Img2Img = 4, // 垫图
  SuperRsolution = 5, // 高清
  Replace = 6, // 替换
  Erase = 7, //擦除
  NegativePrompt = 8, // 去除
  Outpainting = 9, //外延
  OutpaintingPipline = 10, // 外延 工作流模式
  Landscape = -1, // 风景合成 （暂时不用）
}

export interface ModelBasicInfo<K, T> {
  label: K;
  showInfo: K;
  isHot?: boolean;
  value: T;
  version?: string;
}
